// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elevator-pitch {
  width: 100%;
  height: auto;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: left;
}

.elevator-pitch > h1 {
  color: #116466;
}

.elevator-pitch > .picture-and-text {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.elevator-pitch > .picture-and-text > img {
  display: block;
  max-inline-size: 100%;
  block-size: auto;
  aspect-ratio: 90/73;
  object-fit: cover;
  object-position: top center;
  max-height: 468px;
  margin-left: 60px;
  margin-right: 60px;
  border-radius: 10px;
  -webkit-box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);
  -moz-box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);
  box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);
}

.elevator-pitch > .picture-and-text > div {
  max-width: calc(100% - 120px);
  margin-left: 60px;
  margin-right: 60px;
}

@media (max-width: 1360px) {
  .elevator-pitch > .picture-and-text {
    width: 100%;
    flex-direction: column; 
    gap: 20px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .elevator-pitch > .picture-and-text > img {
    max-height: 300px;
  }
  .elevator-pitch > .picture-and-text > div {
    max-width: calc(100% - 240);
    margin-left: 120px;
    margin-right: 120px;
  }
  
  .landing-about-us > p {
    max-width: calc(100% - 60px);
    margin-left: 30px;
    margin-right: 30px;
    padding-left: 20px;
    padding-right: 20px;
    overflow-wrap: break-word;
    word-break: break-all;
  }
}


@media (max-width: 768px) {
  .elevator-pitch > h1 {
    width: calc(100% - 40px);
    text-align: center;
    margin-left: 20px;
    margin-right: 20px;
  }

  .elevator-pitch > .picture-and-text {
    width: 100%;
    flex-direction: column; 
    gap: 20px;
    margin-left: 20px;
    margin-right: 20px;
  }

  .elevator-pitch > .picture-and-text > img {
    max-height: 200px;
    margin-bottom: 20px;
  }
  
  .elevator-pitch > .picture-and-text > div {
    width: calc(100% - 40px);
  }
}`, "",{"version":3,"sources":["webpack://./src/client/Components/Landing/ElevatorPitch/ElevatorPitch.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sDAAsD;EACtD,mDAAmD;EACnD,8CAA8C;AAChD;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;EACA;IACE,2BAA2B;IAC3B,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,4BAA4B;IAC5B,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;EACvB;AACF;;;AAGA;EACE;IACE,wBAAwB;IACxB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".elevator-pitch {\n  width: 100%;\n  height: auto;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: left;\n}\n\n.elevator-pitch > h1 {\n  color: #116466;\n}\n\n.elevator-pitch > .picture-and-text {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.elevator-pitch > .picture-and-text > img {\n  display: block;\n  max-inline-size: 100%;\n  block-size: auto;\n  aspect-ratio: 90/73;\n  object-fit: cover;\n  object-position: top center;\n  max-height: 468px;\n  margin-left: 60px;\n  margin-right: 60px;\n  border-radius: 10px;\n  -webkit-box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);\n  -moz-box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);\n  box-shadow: -7px 6px 14px 1px rgba(0,0,0,0.39);\n}\n\n.elevator-pitch > .picture-and-text > div {\n  max-width: calc(100% - 120px);\n  margin-left: 60px;\n  margin-right: 60px;\n}\n\n@media (max-width: 1360px) {\n  .elevator-pitch > .picture-and-text {\n    width: 100%;\n    flex-direction: column; \n    gap: 20px;\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .elevator-pitch > .picture-and-text > img {\n    max-height: 300px;\n  }\n  .elevator-pitch > .picture-and-text > div {\n    max-width: calc(100% - 240);\n    margin-left: 120px;\n    margin-right: 120px;\n  }\n  \n  .landing-about-us > p {\n    max-width: calc(100% - 60px);\n    margin-left: 30px;\n    margin-right: 30px;\n    padding-left: 20px;\n    padding-right: 20px;\n    overflow-wrap: break-word;\n    word-break: break-all;\n  }\n}\n\n\n@media (max-width: 768px) {\n  .elevator-pitch > h1 {\n    width: calc(100% - 40px);\n    text-align: center;\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .elevator-pitch > .picture-and-text {\n    width: 100%;\n    flex-direction: column; \n    gap: 20px;\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n  .elevator-pitch > .picture-and-text > img {\n    max-height: 200px;\n    margin-bottom: 20px;\n  }\n  \n  .elevator-pitch > .picture-and-text > div {\n    width: calc(100% - 40px);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
